import { useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import { getReferenceName } from '../../utils/walletTransactionReference';

const COLUMNS: CommonListColumn[] = [
    { label: 'ID', field: 'id' },
    { label: 'Amount', field: 'amount' },
    {
        label: 'Customer Id',
        render: (row) => (
            <Link href={`/#/Customers/${row?.customerId}/show`}>{row?.customerId}</Link>
        ),
    },
    {
        label: 'Cook Id',
        render: (row) => (
            <Link href={`/#/Cooks/${row?.cookId}/show`}>{row?.cookId}</Link>
        ),
    },
    {
        label: 'Reference Id',
        render: (row) => (
            <Link
                href={`/#/${getReferenceName(row?.referenceModelName)}/${row?.referenceId}/show`}
            >
                {row?.referenceId}
            </Link>
        ),
    },
    {
        label: 'Reference Model Name',
        render: (row) => row?.referenceModelName || '---',
    },
    {
        label: 'Action',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/VendorTip/${row?.id}/show`}>
                <Button variant="contained" color="primary" size="small">Show</Button>
            </Link>
        ),
    },
];

const VendorTipListForModule = (props: any) => {
    const [page, setPage] = useState(0);

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
        props.refreshData(newPage);
    };

    const handleRowsPerPageChange = (rows: number) => {
        props.setPageSize(rows);
        setPage(0);
        props.refreshData(0);
    };

    return (
        <CommonListTable
            columns={COLUMNS}
            data={props?.data ?? []}
            loading={props?.isLoading}
            page={page}
            rowsPerPage={props?.pageSize}
            total={props?.count ?? 0}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyText="No Tip Found"
        />
    );
};

export default VendorTipListForModule;
